import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto, darkRed, denim, wineRed} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
  },
  flexContainer: {
    flex: 1,
  },
  buttonContainer: {
    position: 'absolute',
    bottom: 5,
    width: '100%',
    padding: indent * 0.1,
    backgroundColor: 'white',
  },
  title: {
    alignSelf: 'flex-start',
  },
  contentContainer: {
    justifyContent: 'space-between',
    flex: 1,
    marginBottom: indent * 2,
  },

  button: {
    borderRadius: 8,
    height: 53,
  },
  container: {
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: denim,
    width: '90%',
    marginLeft: indent * 1,
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 0,
  },
  header: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: indent * 1.2,
    paddingLeft: indent * 0.5,
    marginBottom: 0,
    paddingBottom: 0,
  },
  headerText: {
    fontSize: 14,
    fontWeight: '600',
    marginTop: indent * 0.5,
    paddingLeft: indent * 0.5,
  },
  label: {
    paddingLeft: indent,
    marginBottom: indent * 0.1,
  },
  textStyle: {
    fontWeight: '700',
    color: white,
    fontSize: 14,
    justifyContent: 'center',
  },
  warningText: {
    fontSize: 12,
    fontWeight: '400',

    color: darkRed,
  },
  alertIcon: {
    color: wineRed,
    marginTop: 5,
    marginRight: 8,
    fontSize: 20,
  },
  loading: {
    opacity: 0.5,
  },
  text: {
    marginLeft: indent * 0.4,
    fontSize: 14,
    maxWidth: 150,
  },
  disabled: {
    opacity: 0.5,
    backgroundColor: 'grey',
  },
  infoContainer: {
    flexDirection: 'row',
    fontSize: 12,
    fontWeight: '400',
    color: darkRed,
  },
});
